import { useMutation } from 'react-query';

import { requestFileUpload } from '../network/services/fileUpload.service';

export const useFileUploader = () => {
  return useMutation(requestFileUpload);
};
